import { gapi } from "gapi-script";
import { generateSanitizedFilename } from "./AzureStorage.service";
import { setGoogleUploadForClientProfile, setGoogleUploadForJournalImage } from "../../actions";

export const findFolder = async (folderName, parentId = null) => {
    let query = `name='${folderName}' and mimeType='application/vnd.google-apps.folder' and trashed=false`;
    if (parentId) {
        query += ` and '${parentId}' in parents`;
    }
    try {
        const response = await gapi.client.drive.files.list({
            q: query,
            fields: 'files(id, name)',
            spaces: 'drive',
        });
        const files = response.result.files;
        if (files.length > 0) {
            return files[0].id;
        } else {
            return null;
        }
    } catch (error) {
        return error;
    }
};

export const uploadFilesToFolder = async (files, folderId) => {
    const uploadFile = async (file) => {
        const { blobObjectNameWithExtension } = generateSanitizedFilename(file.name);

        const metadata = {
            name: blobObjectNameWithExtension,
            mimeType: file.type,
            parents: [folderId], // Add the file to the specified folder
        };
        const form = new FormData();
        form.append("metadata", new Blob([JSON.stringify(metadata)], { type: "application/json" }));
        form.append("file", file);

        try {
            const response = await fetch("https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart", {
                method: "POST",
                headers: new Headers({ "Authorization": "Bearer " + gapi.auth.getToken().access_token }),
                body: form,
            });
            const data = await response.json();
            data.imageUrl = getAuthenticatedImageUrl(data.id);
            return data;
        } catch (error) {
            return error;
        }
    }
    try {
        const uploadPromises = files.map(file => uploadFile(file));
        const results = await Promise.all(uploadPromises);
        return results;
    } catch (error) {
        console.error('Error uploading multiple files:', error);
        return error;
    }
};

export const createFolder = async (folderName, parentId = null) => {
    const folderMetadata = {
        name: folderName,
        mimeType: 'application/vnd.google-apps.folder',
        parents: parentId ? [parentId] : [],
    };

    try {
        const response = await gapi.client.drive.files.create({
            resource: folderMetadata,
            fields: 'id',
        });
        const folderId = response.result.id;
        return folderId;
    } catch (error) {
        return error;
    }
};

export const getFilesInFolder = async (folderId, fileName) => {
    let query = `'${folderId}' in parents and trashed=false`;
    if (fileName) {
        query += `  and name='${fileName}'`;
    }
    var urlFiles = [];
    try {
        const response = await gapi.client.drive.files.list({
            q: query,
            fields: 'files(id, name, mimeType)',
        })
        const files = response.result.files;
        if (files && files.length > 0) {
            urlFiles = files.map(x => ({ ...x, imageName: x.name, imageUrl: getAuthenticatedImageUrl(x?.id) }));
        } else {
            console.log('No files found in folder');
        }
        return urlFiles;
    } catch (error) {
        console.error('Error fetching files', error);
        return error;
    }
};

const getAuthenticatedImageUrl = (fileId) => {
    return `https://lh3.googleusercontent.com/d/${fileId}`;
};

export const deleteClientProfileData = async (fileData) => {
    var boolean = false;
    try {
        const response = await gapi.client.drive.files.delete({
            'fileId': fileData.isGoogleImage
        });
        await setGoogleUploadForClientProfile('', fileData.clientId);
        boolean = true;
    } catch (error) {
        console.error('Error deleting file:', error);
        boolean = false;
    }
    return boolean;
};

export const deleteJournalData = async (deleteFileData, updatedGDFiles, journalId) => {
    let boolean = false;
    try {
        const response = await gapi.client.drive.files.delete({
            'fileId': deleteFileData.isGoogleImage
        });
        if (response) {
            await setGoogleUploadForJournalImage(updatedGDFiles.map(fileData => fileData.imageName).join(','), deleteFileData.clientId, journalId);
        }
        boolean = true;
    } catch (error) {
        console.error('Error deleting file:', error);
    }
    return boolean;
};